import React, { useContext } from 'react'
import { useDispatch } from 'react-redux'
import { SpinnerContext } from '../../context/spinnerContext'
import { yupResolver } from '@hookform/resolvers/yup'
import { Controller, useForm } from 'react-hook-form'
import { errorToast, successToast } from '../../util/Toast/toast'
import { addPaymentSchema } from '../../util/validationSchema'
import { addExtraPayment } from '../../redux/slices/cleanersSlice'

const AddPaymentForm = ({ togglePaymentModal, setIsRefresh, cleaning_id }) => {
  const dispatch = useDispatch()
  const { changeLoader } = useContext(SpinnerContext)

  const { handleSubmit, control, trigger, reset } = useForm({
    resolver: yupResolver(addPaymentSchema),
    defaultValues: {}
  })

  const onSubmit = (data) => {
    setIsRefresh(false)
    const payload = {
      id: cleaning_id,
      data: data
    }

    dispatch(addExtraPayment(payload)).then(({ payload, error }) => {
      if (payload?.status === 200) {
        successToast(payload?.data?.status_message || 'Success!')
        setIsRefresh(true)
        changeLoader(false)
        reset()
        togglePaymentModal()
      } else {
        errorToast(payload?.data?.status_message || error?.message)
        changeLoader(false)
      }
    })
  }
  return (
    <div className="container-fluid">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="form-group position-relative">
              <label>
                Service Value<span className="text-danger"> *</span>
              </label>

              <Controller
                name={`service_amount`}
                control={control}
                render={({ field: { value, onChange }, fieldState }) => (
                  <>
                    <div className="form-control-icon-wrap">
                      <input
                        className="form-control form-control-with-icon"
                        value={value}
                        type="number"
                        placeholder="Enter Service Value"
                        onChange={(val) => {
                          onChange(val)
                          trigger(`service_amount`)
                        }}
                      />
                    </div>
                    <span className="info_box_div" style={{ top: '65%', right: '10px' }}>
                      <span>$</span>
                    </span>
                    <small>{fieldState?.error?.message}</small>
                  </>
                )}
                defaultValue=""
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-12 col-sm-12">
            <div className="form-group">
              <label>
                Reason<span className="text-danger"> *</span>
              </label>
              <Controller
                name={`reason`}
                control={control}
                render={({ field: { value, onChange }, fieldState }) => (
                  <>
                    <input
                      className="form-control"
                      value={value}
                      type="text"
                      placeholder="Enter Reason"
                      onChange={(val) => {
                        onChange(val)
                        trigger(`reason`)
                      }}
                    />
                    <small>{fieldState?.error?.message}</small>
                  </>
                )}
                defaultValue=""
              />
            </div>
          </div>
        </div>
        <div className="row mb-3">
          <div className="multi_btn_div">
            <button type="button" className="btn common-outline-btn w-100" onClick={() => togglePaymentModal()}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary common-field-btn w-100">
              {`Save`}
            </button>
          </div>
        </div>
      </form>
    </div>
  )
}

export default AddPaymentForm
